export const getCommentsByCommentableAndType = (state, commentable) => {
  return state
    .filter((comment) => comment.commentable === commentable)
    .sort((a, b) => a.createdAt - b.createdAt)
}
